<template>
  <div>
    <empty-box class="query-form">
      <a-form-model :model="searchForm" layout="inline" ref="searchForm">
        <a-form-model-item label="app类型" prop="appType">
          <a-select v-model="searchForm.appType" placeholder="请选择" class="w140" @change="handleQuery">
            <a-select-option value="DYNAMIC_SIGNAL_ANALYSER">动态信号分析</a-select-option>
            <a-select-option value="SOUND_COLLECTION">声音采集</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="设备编号" prop="deviceNo">
          <a-input v-model="searchForm.deviceNo" placeholder="请输入设备编号" allowClear />
        </a-form-model-item>
        <a-form-model-item label="申请发票状态" prop="invoiceStatus">
          <a-select v-model="searchForm.invoiceStatus" placeholder="请选择" class="w140" @change="handleQuery">
            <a-select-option value="0">不可申请</a-select-option>
            <a-select-option value="1">可申请</a-select-option>
            <a-select-option value="2">申请中</a-select-option>
            <a-select-option value="3">可下载</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item>
          <a-button type="primary" @click="handleQuery">查询</a-button>
        </a-form-model-item>
        <a-form-model-item>
          <a-button @click="resetForm">重置</a-button>
        </a-form-model-item>
      </a-form-model>
    </empty-box>

    <a-table :columns="columns" :data-source="list" bordered :pagination="false" class="table-list" :rowKey="(record) => record.orderId">
      <span slot="createTime" slot-scope="text">{{ moment(text).format("YYYY-MM-DD HH:mm:ss") }}</span>
      <span slot="orderAmount" slot-scope="text">{{ text/100 }}</span>
      <span slot="payAmount" slot-scope="text">{{ text/100 }}</span>
      <template slot="payStatus" slot-scope="text">
        <a-tag v-if="text == 1" color="red">未付款</a-tag>
        <a-tag v-if="text == 2" color="green">已付款</a-tag>
      </template>
      <span slot="action" slot-scope="record">
        <a-button type="link" @click="handleDetail(record)">详情</a-button>
      </span>
    </a-table>


    <a-modal
      v-model="visible"
      title="订单详情"
      width="1000px"
      :footer="null">
        <a-table :columns="detailColumns" :data-source="detail" :pagination="false" class="table-list">
            <div slot="expandedRowRender" slot-scope="record" style="margin: 0">
                <a-table :columns="goodsColumns" :data-source="record.functionList" :pagination="false" class="table-list">
                    <span slot="price" slot-scope="text">{{ text/100 }}</span>
                </a-table>
            </div>
            <span slot="totalAmount" slot-scope="text">{{ text/100 }}</span>
            <span slot="orderAmount" slot-scope="text">{{ text/100 }}</span>
        </a-table>
    </a-modal>
  </div>
</template>

<script>
import { queryOrderList } from '@/api/api'
import moment from 'moment'
const columns = [
  {
    title: '订单编号',
    dataIndex: 'orderId',
    key: 'orderId',
    align: 'center'
  },
  {
    title: '订单金额(元)',
    dataIndex: 'orderAmount',
    key: 'orderAmount',
    align: 'center',
    scopedSlots: { customRender: 'orderAmount' },
  },
  {
    title: '实付金额(元)',
    dataIndex: 'payAmount',
    key: 'payAmount',
    align: 'center',
    scopedSlots: { customRender: 'payAmount' },
  },
  {
    title: '支付状态',
    dataIndex: 'payStatus',
    key: 'payStatus',
    align: 'center',
    scopedSlots: { customRender: 'payStatus' },
  },
  {
    title: '下单时间',
    dataIndex: 'createTime',
    key: 'createTime',
    align: 'center',
    scopedSlots: { customRender: 'createTime' },
  },
  {
    title: '操作',
    key: 'action',
    align: 'center',
    scopedSlots: { customRender: 'action' },
  },
]
const detailColumns = [
  {
    title: '设备编号',
    dataIndex: 'deviceNo',
    key: 'deviceNo',
    align: 'center'
  },
  {
    title: '设备型号',
    dataIndex: 'deviceModel',
    key: 'deviceModel',
    align: 'center'
  },
  {
    title: '产品id',
    dataIndex: 'productId',
    key: 'productId',
    align: 'center'
  },
  {
    title: '总金额(元)',
    dataIndex: 'totalAmount',
    key: 'totalAmount',
    align: 'center',
    scopedSlots: { customRender: 'totalAmount' },
  },
  {
    title: '订单优惠后金额(元)',
    dataIndex: 'orderAmount',
    key: 'orderAmount',
    align: 'center',
    scopedSlots: { customRender: 'orderAmount' },
  },
  {
    title: '优惠明细',
    dataIndex: 'reduceDetail',
    key: 'reduceDetail',
    align: 'center'
  },
]

const goodsColumns = [
    {
        title: '功能名称',
        dataIndex: 'functionName',
        key: 'functionName',
        align: 'center'
    },
    {
        title: '功能id',
        dataIndex: 'functionId',
        key: 'functionId',
        align: 'center'
    },
    {
        title: '功能描述',
        dataIndex: 'description',
        key: 'description',
        align: 'center'
    },
    {
        title: '商品数量',
        dataIndex: 'goodsNumbers',
        key: 'goodsNumbers',
        align: 'center'
    },
    {
        title: '单价(元)',
        dataIndex: 'price',
        key: 'price',
        align: 'center',
        scopedSlots: { customRender: 'price' },
    },
]

export default {
  data() {
    return {
        moment,
      searchForm: {
        appType: undefined,
        deviceNo: '',
        invoiceStatus: undefined,
      },
      list: [],
      columns,
      visible: false,
      detailColumns,
      detail: [],
      goodsColumns,
    }
  },
  methods: {

    // 获取订单列表
    getOrderList() {
      const para = {
        appType: this.searchForm.appType,
        deviceNo: this.searchForm.deviceNo,
        invoiceStatus: this.searchForm.invoiceStatus
      }

      queryOrderList(para).then(({ response }) => {
        this.list = response.dataList
      })
    },

    // 查看详情
    handleDetail(row) {
      this.detail = row.orderDetails

      console.log(this.detail)

      this.detail = this.detail.map(item => {
        return {
            ...item,
            ...item.priceInfo
        }
      })

      console.log(this.detail)
      

      this.$nextTick(() => {
        this.visible = true
      })
    },

    handleOk() {

    },

    handleQuery() {
      this.getOrderList()
    },
    resetForm() {
      this.$refs['searchForm'].resetFields()
      this.getOrderList()
    }
  },

  created() {
    this.getOrderList()
  }
}
</script>

<style lang="less" scoped>
  .info {
    padding: 30px 0;
  }
</style>